import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: [],
    error: "",
    dislaimerText: {},
  },
  action
) {
  switch (action.type) {
    case homeConstants.ALTERNATE_LIST_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.ALTERNATE_LIST_SUCCESS:
      return {
        data: action.response.data.alternateList,
        dislaimerText: action.response.data.dislaimerText,
        isProgress: false,
      };
    case homeConstants.ALTERNATE_LIST_FAILURE:
      return {
        data: [],
        dislaimerText: {},
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        data: [],
        dislaimerText: {},
      };
    default:
      return state;
  }
}
